import { WaitList } from './sidePanel/waitList/WaitList';

export const WaitlistSidePanel = () => <WaitList />;
